import { Headset } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0F172A]/50 py-16">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 md:grid-cols-12">
        <div className="md:col-span-5">
          <img
            src="/assets/coin-adda-logo.png"
            alt="Coin Adda — USDT to INR Exchange"
            className="h-10 w-auto"
            data-testid="footer-logo"
          />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Coin Adda is a simple, secure USDT to INR exchange platform.
            Deposit USDT in the app and receive INR directly in your bank
            account.
          </p>
        </div>

        <div className="md:col-span-4">
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Support</h3>
          <div className="mt-5 flex items-start gap-3" data-testid="footer-support">
            <Headset size={22} weight="duotone" className="mt-0.5 shrink-0 text-[#00F5A0]" />
            <p className="text-sm leading-relaxed text-slate-400">
              Need help? Reach our team anytime through the{" "}
              <span className="font-semibold text-slate-200">Contact Support</span>{" "}
              option inside the Coin Adda app.
            </p>
          </div>
        </div>

        <div className="md:col-span-3">
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Legal</h3>
          <ul className="mt-5 space-y-3">
            <li>
              <a
                href="#"
                data-testid="footer-privacy-link"
                className="text-sm text-slate-400 transition-colors duration-300 hover:text-[#00F5A0]"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="#"
                data-testid="footer-terms-link"
                className="text-sm text-slate-400 transition-colors duration-300 hover:text-[#00F5A0]"
              >
                Terms &amp; Conditions
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-14 flex max-w-7xl flex-col gap-3 border-t border-white/10 px-5 pt-8 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <p className="text-xs text-slate-500" data-testid="footer-copyright">
          © 2026 Coin Adda. All rights reserved.
        </p>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-600">
          USDT → INR Exchange
        </p>
      </div>
    </footer>
  );
}
